import * as React from 'react';

import { cn } from '@/utils/utils_client';

export const UI_PRIMITIVE__card_header = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} />
));
UI_PRIMITIVE__card_header.displayName = 'CardHeader';

export const UI_PRIMITIVE__card_title = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('text-2xl font-semibold leading-none tracking-tight', className)} {...props} />
));
UI_PRIMITIVE__card_title.displayName = 'CardTitle';

export const UI_PRIMITIVE__card_description = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
));
UI_PRIMITIVE__card_description.displayName = 'CardDescription';

export const UI_PRIMITIVE__card_content = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />
));
UI_PRIMITIVE__card_content.displayName = 'CardContent';

export const UI_PRIMITIVE__card_footer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex items-center p-6 pt-0', className)} {...props} />
));
UI_PRIMITIVE__card_footer.displayName = 'CardFooter';
